import _ from 'underscore';

const getUriWithParam = (baseUrl, params) => {
  const Url = new URL(baseUrl);
  const urlParams = new URLSearchParams(Url.search);

  Object.keys(params).forEach((key) => {
    urlParams.set(key, params[key]);
  });

  Url.search = urlParams.toString();

  return Url.toString();
};

const getThumbnailServiceUrl = (bingUrl, w, h) =>
  getUriWithParam(bingUrl, { w, h, c: 16 }); // &c=16 means smart crop

export const IMAGE_WIDTH_PX = 126;
export const IMAGE_HEIGHT_PX = 71;

export const getImageExtensionItemThumbnailUrl =
  (item) => {
    // using the 1.78:1 ratio to create the thumbnail
    const itemImage = _.find(item.Images, image => image.Asset.SubType === 'ImageMedia178X100');

    if (itemImage) {
      return getThumbnailServiceUrl(itemImage.Asset.ImageUrl, IMAGE_WIDTH_PX, IMAGE_HEIGHT_PX);
    }

    return null;
  };
